import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  ImportProcurementSuppliersDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";
import { ACTION_GET_PROCUREMENT_SUPPLIERS } from "../GetProcurementSuppliers";

import { procurementApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_IMPORT_PROCUREMENT_SUPPLIERS = "IMPORT_PROCUREMENT_SUPPLIERS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const importProcurementSuppliers = async (
  props: ImportProcurementSuppliersDto,
): Promise<void> => {
  const response =
    await procurementApi.procurementControllerImportProcurementSuppliers(props);

  return response.data;
};

export const useImportProcurementSuppliers = (
  user: UserProfileDto | null,
): {
  importProcurementSuppliers: (props: ImportProcurementSuppliersDto) => void;
  importProcurementSuppliersAsync: (
    props: ImportProcurementSuppliersDto,
  ) => Promise<void>;
  importProcurementSuppliersEnabled: boolean;
  isSuccessImportProcurementSuppliers: boolean;
  isPendingImportProcurementSuppliers: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_IMPORT_PROCUREMENT_SUPPLIERS],
    mutationFn: enabled ? importProcurementSuppliers : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PROCUREMENT, ACTION_GET_PROCUREMENT_SUPPLIERS],
      });
    },
  });

  return {
    importProcurementSuppliers: mutate,
    importProcurementSuppliersAsync: mutateAsync,
    importProcurementSuppliersEnabled: enabled,
    isSuccessImportProcurementSuppliers: isSuccess,
    isPendingImportProcurementSuppliers: isPending,
  };
};
